import { getAuthData } from '@common/helpers/auth';
import Config from '../config/main';

export const getTerminalLanguage = () => {
  const authData = getAuthData();
  const { betshopid: betshopId } = authData || {};

  const customLang = Config.perBetshopLanguages.find((data) => data.ids.includes(+betshopId))?.lang;

  return customLang || Config.env.lang;
};
